/**
 * PageTitle - Quiz-styled page title component
 */

import React from "react";
import { Box, Typography } from "@mui/material";
import { QUIZ } from "@/theme/quizTokens";

interface PageTitleProps {
  title: string;
  subtitle?: string;
}

export function PageTitle({ title, subtitle }: PageTitleProps) {
  return (
    <Box sx={{ mb: { xs: 3, md: 4 } }}>
      <Typography
        sx={{
          fontFamily: QUIZ.font.display,
          fontWeight: 800,
          fontSize: { xs: "26px", sm: "32px", md: "48px" },
          lineHeight: { xs: 1.05, md: "100%" },
          color: QUIZ.color.brown,
          mb: subtitle ? 1 : 0,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          sx={{
            fontFamily: QUIZ.font.body,
            fontWeight: 400,
            fontSize: { xs: "14px", sm: "15px", md: "16px" },
            lineHeight: { xs: "20px", md: "24px" },
            color: QUIZ.color.brown,
            opacity: 0.75,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
